import { updateObject } from "./utility";
import {
  ALL_PROJECT_LIST,
  ALL_USER_GROUP_LIST,
  COMBO_PROJECT_USER,
  ALL_CUSTOMERS,
  SELECTED_USER,
  SELECTED_CUSTOMER_ADMIN,
  SELECTED_PROJECT,
  SELECTED_CUSTOMER,
  PROJECT_SEARCH,
  ALL_CUSTOMER_LIST_ADMIN,
  BENEFIT_DATA,
  SHOW_PROJECTS,
} from "Stores/actionTypes";

const INIT_STATE = {
  allUserGroupForAdmin: null,
  allProjectComboUser: null,
  allCustomers: [],
  selectedUser: null,
  selectedCustomerAdmin: null,
  selectedCustomer: null,
  projectsList: [],
  projectsListPagination: { Limit: 5, Page: 1, Total: 0 },
  selectedProject: null,
  projectDataSearch: null,
  allCustomerForAdmin: null,
  benefitData: [],
  benefitInfo: null,
  onClickShowProject: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case BENEFIT_DATA:
      return updateObject(state, {
        benefitData: action.benefitData,
        benefitInfo: action.benefitInfo,
      });
    case PROJECT_SEARCH:
      return updateObject(state, {
        projectDataSearch: action.projectDataSearch,
      });
    case SELECTED_PROJECT:
      return updateObject(state, { selectedProject: action.selectedProject });
    case SELECTED_CUSTOMER:
      return updateObject(state, { selectedCustomer: action.selectedCustomer });
    case SELECTED_CUSTOMER_ADMIN:
      return updateObject(state, {
        selectedCustomerAdmin: action.selectedCustomerAdmin,
      });
    case ALL_CUSTOMER_LIST_ADMIN:
      return updateObject(state, {
        allCustomerForAdmin: action.allCustomerForAdmin,
      });
    case SELECTED_USER:
      return updateObject(state, { selectedUser: action.selectedUser });
    case ALL_CUSTOMERS:
      return updateObject(state, { allCustomers: action.allCustomers });

    case ALL_PROJECT_LIST:
      return updateObject(state, {
        projectsList: action.projectsList,
        projectsListPagination: action.projectsListPagination,
      });
    case ALL_USER_GROUP_LIST:
      return updateObject(state, {
        allUserGroupForAdmin: action.allUserGroupForAdmin,
      });
    case COMBO_PROJECT_USER:
      return updateObject(state, {
        allProjectComboUser: action.allProjectComboUser,
      });
    case SHOW_PROJECTS:
      return updateObject(state, {
        onClickShowProject: action.value,
      });

    default:
      return state;
  }
};
